import { Directive, Input, TemplateRef, ViewContainerRef } from "@angular/core";
import { OnInit } from "@angular/core";
import { ACLService } from '../../../services/acl.service';
import { AuthenticationService } from '../../../services/authentication.service';

@Directive({
  selector: "[acl]",
})
export class ACLDirective implements OnInit {
  private value;
  private data: any = [];

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private _authService: AuthenticationService,
    private aclService: ACLService,
  ) {}
  ngOnInit(): void {
    this.aclService.currentUserPermission.subscribe((data) => {
      if (!data) this.data = [];
      else {
        this.data = data;
      }
       this.updateView();
    });
  }

  @Input()
  set acl(val: string | string[]) {
    this.value = val;
    this.updateView();
  }

  private updateView() {
    this.viewContainer.clear();
    if ((Array.isArray(this.value) ? this.value.length <= 0 : !this.value)) {
      this.viewContainer.clear();

    }
    else if (this._authService.userContext.isSuperUser) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
    else {
      if (this.data.length > 0) {
        let status = false;
        
        if (Array.isArray(this.value)) {
          status = this.data.some((x) => this.value.some(y=>y==x));
        } else {
          status = this.data.some((x) => x == this.value);
        }

        if (status) {
          this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
          this.viewContainer.clear();
        }

      } else {
        this.viewContainer.clear();
      }
    }
  }
}
